module.exports = __webpack_public_path__ + "iphone14-frame.png?b2a4d2b22cb8aa1e6bd1c535ba03c64a";